export { ISelectionOptions, Selection } from '@uifabric/utilities';



// WEBPACK FOOTER //
// ../src/utilities/selection/Selection.ts